import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { GlobalBox } from "components/Box/GlobalBox";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { useSearch } from "hooks/useSearch";
import { setReportInvoiceRelationshipFilters, getReportInvoiceRelationshipAction } from "redux/actions/Reports/reportInvoiceRelationship/reportInvoiceRelationshipActions";

export const ReportInvoiceRelationshipView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportInvoiceRelationship }) => reportInvoiceRelationship);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportInvoiceRelationshipAction({ startDate, endDate, station }));
  };

  const handleExcel = (e) => {
    e.preventDefault();
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return;
    dispatch(getReportInvoiceRelationshipAction({ startDate, endDate, station, isPdf: false }));
  };

  return (
    <GlobalBox title="Reporte Facturación con Notas" icon={<ReceiptIcon />}>
      {isLoadingComp?.loadingReportInvoiceRelationship ? <LoadingComponent /> :
        <TableInputs
          reducer="reportInvoiceRelationship"
          dates
          stations
          maxDate={newDate()}
          dispatchAction={setReportInvoiceRelationshipFilters}
          submitAction={handleSubmit}
          submitButtonName="PDF"
          submitSecond={handleExcel}
        />
      }
    </GlobalBox>
  );
};
